const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/loop/$loopId/visualizations/main/route.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, redirect } from '@tanstack/react-router';
type MainRoadmapBeforeLoadArgs = {
  context: {
    flags: {
      enableCombinedPortfolioAndVisualizationsTab: boolean;
    };
  };
  params: {
    loopId: number;
    org: string;
  };
};
export const visualizationsMainBeforeLoad = ({
  context,
  params
}: MainRoadmapBeforeLoadArgs) => {
  if (context.flags.enableCombinedPortfolioAndVisualizationsTab) {
    throw redirect({
      to: '/org/$org/loop/$loopId/portfolio/table',
      params,
      search: true,
      replace: true
    });
  }
};
export const Route = createFileRoute('/(app)/org/$org/loop/$loopId/visualizations/main')({
  beforeLoad: visualizationsMainBeforeLoad,
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});